"use client"

import { useLanguageContext } from "../../../Languages/Langs/LanguageContext";
import { FooterContainer, FooterContainerDescribeInfo, FooterDescribeText, FooterSection, FooterTitle } from "./Footer.styled";

export const Footer = () => {
  const { t } = useLanguageContext();

  const websiteLink: string = "https://picsworldstudio.com/";

  return (
    <>
      <FooterSection>
        <FooterContainer>
          <FooterContainerDescribeInfo>
          {/* add custom cursor for link */}
            <FooterTitle target="_blank" rel="noopener noreferrer nofollow" href={websiteLink}>PicsWorldStudio</FooterTitle>
            <FooterDescribeText>{t("publicTranslate.footerText")}</FooterDescribeText>
          </FooterContainerDescribeInfo>
        </FooterContainer>
      </FooterSection>
    </>
  );
};
